<template>
  <div class="tab-nav" :class="theme">
    <div
      class="tab-nav-item"
      :class="{ 'tab-active': loginDialogType == item.type }"
      v-for="item in navList"
      :key="item.type"
      @click="changeTab(item)"
    >
      {{ item.title }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineEmits, defineProps } from 'vue';
import { storeToRefs, useAppStore } from '@star/stores';

type Item = {
  title: string;
  type: number;
};

type Props = {
  navList: Item[];
  loginDialogType?: number;
};

const props = defineProps<Props>();

const emit = defineEmits(['changeTabType']);
const { theme } = storeToRefs(useAppStore());

const changeTab = (item: Item) => {
  emit('changeTabType', item.type);
};
</script>

<style scoped lang="less">
.tab-nav {
  width: 100%;
  display: flex;
  text-align: center;
  justify-content: space-between;
  border-radius: 60px 60px 0 0;
  overflow: hidden;
  margin-bottom: 60px;

  .tab-nav-item {
    width: 50%;
    height: 140px;
    color: #8a8a8a;
    background: #ebebeb;
    font-size: 56px;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;

    &.tab-active {
      background: #fff;
      color: var(--theme-primary-color);
      font-weight: 600;
    }

    &:nth-child(1) {
      border-radius: 0 0 60px 0;
    }

    &:nth-child(2) {
      border-radius: 0 0 0 60px;
    }
  }

  &.dark {
    justify-content: flex-start;
    padding-top: 60px;
    padding-left: 60px;

    .tab-nav-item {
      width: 223px;
      height: 97px;
      border-radius: 49px;
      font-weight: 500;
      font-size: 48px;
      margin-right: 30px;
      background: #33374a;
      color: #d7daeb;

      &.tab-active {
        background: var(--theme-btn-primary-background);
        color: var(--van-button-primary-color);
        font-weight: 600;
      }
    }
  }
}
</style>
